var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgBrandedGames = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9372_70133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4185 12.3516C12.1444 11.3518 11.1722 10.7302 10.2276 10.2266C8.75925 9.44456 7.35463 8.75287 5.87775 7.96875C5.13719 7.57669 4.42 7.20906 3.88556 6.67356C3.22469 6.01375 2.68494 4.95338 2.52344 3.98438C2.47031 3.66562 2.45756 3.17263 2.45756 2.65625C1.69469 3.30225 1.04869 4.33394 0.631125 5.41237C0.308125 6.24431 0.051 7.15913 0 8.1685C0 8.40013 0 8.63387 0 8.8655C0.129625 11.2551 1.12838 13.0369 2.39062 14.4107C3.65819 15.7887 5.50481 16.7397 7.83594 17C8.21312 17 8.58925 17 8.96537 17C9.91631 16.8512 10.7142 16.4124 11.3231 15.7717C11.9829 15.0758 12.8074 13.7647 12.4185 12.3516Z",
    fill: "#CCD6F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.76554 0C8.62104 0 8.47761 0 8.33417 0C7.46079 0.146625 6.60867 0.396313 6.10929 0.963688C5.75867 1.36106 5.48242 2.06869 5.44523 2.52344C5.28798 4.47737 6.68836 5.18819 8.00161 5.87775C9.36267 6.59069 10.7684 7.31531 12.1528 8.03569C12.8657 8.40756 13.5149 8.79112 14.0122 9.33087C14.9174 10.3126 15.4827 11.5919 15.3732 13.4481C15.5974 13.2313 15.8004 12.9285 15.9704 12.6183C16.4644 11.7151 16.8639 10.5644 16.967 9.231C16.9617 9.19169 16.9734 9.1715 16.9999 9.16406C16.9999 8.721 16.9999 8.279 16.9999 7.83594C16.4155 3.16519 13.2365 0.360187 8.76554 0Z",
    fill: "#CCD6F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9372_70133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBrandedGames);
export default ForwardRef;